import { GeoRecordMode, WebRecordingSettings } from '@fullstory/proto/fs/services/orgs';
import { SettingsResponse } from '@fullstory/proto/fs/api/clientapi';
import { int64 } from '@fullstory/proto/google/protobuf';

export const GET_WEB_RECORDING_SETTINGS_RESPONSE: WebRecordingSettings = {
  recordingEnabled: true,
  consoleWatcherEnabled: true,
  ajaxWatcherEnabled: true,
  onlyRecordKnownDomains: false,
  domains: [],
  watches: [],
  recordGeoMode: GeoRecordMode.GEO_WHITELIST,
  recordGeoZones: [],
  blockedIps: [],
  blockedUas: [],
  blockedAppIds: [],
  resourceUploadingEnabled: false,
};

export const GET_SETTINGS_RESPONSE: SettingsResponse = {
  quotaSessionsUsed: 1,
  quotaCycleStart: null,
  quotaCycleEnd: null,
  trafficFiltering: 1,
  disabled: false,
  plan: null,
  usedSeats: 1,
  umbrellaName: 'Test Name',
  nextBillDate: null,
  coupons: [],
  quotaSessionsUsedCount: int64.fromNumber(0),
  allowAddPaymentInfo: false,
  serverEventsUsed: int64.fromNumber(3),
};

export const GET_SETTINGS_WITH_PLAN_RESPONSE: SettingsResponse = {
  ...GET_SETTINGS_RESPONSE,
  plan: {
    sessions: int64.fromNumber(1),
    seats: 1,
    quotaLength: 0,
    alerts: null,
    anchor: null,
    interval: 0,
    basePlan: 0,
    planStage: 0,
    trialExpiration: null,
    cancellation: null,
    history: 1,
    price: 0,
    packs: [],
    invoiced: false,
    salesMananger: null,
    notes: '',
    analyticsHistory: 1,
    allowAddPaymentInfo: false,
    serverEvents: int64.fromNumber(1),
    changeLog: [],
    retentionPeriodUnit: 1,
    splitProcessingSampleRate: 0,
  },
};
